<h2 mat-dialog-title>Confirmation de suppression</h2>
<mat-dialog-content>
<div class="panel panel-default ">
	  <div [ngClass]="" class="panel-body">
      Veuillez confirmer la suppression de ce message
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Annuler</button>
    <button mat-button mat-dialog-close class="btn btn-success" (click)="confirmDelete()">Confirmer</button>
</mat-dialog-actions>